import { Helmet } from "react-helmet";
import { DashboardLayout } from "../../../../../components/layouts/DashboardLayout";
import { Header } from "../../../../../components/Header";
import { useState } from "react";
import {
  FaServer,
  FaNetworkWired,
  FaArrowLeft,
  FaCopy,
  FaClipboardCheck,
  FaTerminal,
  FaBookOpen,
  FaDownload,
  FaKey,
} from "react-icons/fa6";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useHookNasDetail } from "../../../../../hooks/useHookNasDetail";
import { FaShieldAlt } from "react-icons/fa";
import { UpdateNasName } from "../modals/UpdateName";
import { ConnectionStatusBadge } from "../../../../../components/badge/ConnectionStatusBadge";
import { NasDetailInfoItem } from "./info_item";

/* ============================================
   KOMPONEN: NasDetail
   ============================================ */
export const NasDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [openSidebar, setOpenSidebar] = useState(false);
  const [copied, setCopied] = useState(false);

  const [openModalUpdateName, setOpenModalUpdateName] = useState(false);
  // Fetch Data from API
  const { data, isLoading, error, refreshData } = useHookNasDetail({ id: id });

  // Fallback jika data belum ada
  const nas = data || {};

  // --- HELPER VARIABLES ---
  const tunnelIpCidr = nas.ip_address || "10.100.0.2/30";
  const pppoeCidr = nas.ip_pppoe || "10.10.4.0/22";
  const hsCidr = nas.ip_hotspot || "172.16.4.0/22";
  const peerPublicKey = "17hleGoiJg3rXi6zMtPGZI8t9eSFiKWCsA3A6CcidHs=";

  // Mengambil IP Address (tanpa CIDR) untuk keperluan tertentu
  const tunnelIp = tunnelIpCidr.split('/')[0];
  const pppoeBase = pppoeCidr.split('.0')[0];
  const hsBase = hsCidr.split('.0')[.0];

  // --- LOGIKA GENERASI SCRIPT DINAMIS ---
  const scriptContent = `# DANELA NET - MikroTik Auto Provisioning
# Generated for NAS: ${nas.shortname || "Unknown"}

# ==========================================
# 2. SETUP IP ADDRESS POOLS
# ==========================================
# Setup Pool PPPoE (Range: .2 s/d .254)
/ip pool add name=pool-pppoe ranges=${pppoeBase}.2-${pppoeBase}.254 comment="PPPoE Pool-RadiusTrend"

# Setup Pool Hotspot (Range: .2 s/d .254)
/ip pool add name=pool-hs ranges=${hsBase}.2-${hsBase}.254 comment="Hotspot Pool-RadiusTrend"


# ==========================================
# 3. SETUP WIREGUARD & PEER
# ==========================================
# Membuat Interface WireGuard
/interface wireguard add name=wg_radiustrend mtu=1420 comment="Tunnel to Core-RadiusTrend"

# Ganti YOUR_PRIVATE_KEY dengan key yang dihasilkan dari /interface wireguard generate-key
# /interface wireguard set wg_radiustrend private-key="YOUR_GENERATED_PRIVATE_KEY_HERE"

# Set IP Address untuk Tunnel WireGuard
/ip address add address=${tunnelIpCidr}/24 interface=wg_radiustrend comment="WireGuard Link - RadiusTrend"

# Konfigurasi Peer Core Server
/interface wireguard peers add \\
    interface=wg_radiustrend \\
    public-key="${peerPublicKey}" \\
    endpoint-address=103.253.212.48 \\
    endpoint-port=51820 \\
    allowed-address=${tunnelIpCidr}/24,${pppoeCidr},${hsCidr} \\
    persistent-keepalive=25s \\
    comment="Core Server Peer-RadiusTrend"

# ==========================================
# 4. ADDITIONAL SERVICES (DHCP, RADIUS, NAT)
# ==========================================
# Enable DHCP Server PPPoE
/ip dhcp-server add name=dhcp-pppoe interface=vlan-pppoe address-pool=pool-pppoe disabled=no

# Enable DHCP Server Hotspot
/ip dhcp-server add name=dhcp-hs interface=vlan-hs address-pool=pool-hs disabled=no

# RADIUS Configuration
/radius 
  add address=123.123.0.1 \\
  secret=${nas.secret || "danelaRadius2024"} \\
  service=ppp,hotspot,login,dhcp timeout=300ms  \\
  src-address=${nas.ip_address}

# Enable AAA Radius
/ppp aaa set use-radius=yes accounting=yes
/ip hotspot aaa set use-radius=yes

# Enable Incoming Radius
/radius incoming set accept=yes port=1700 vrf=main

# NAT Configuration (Masquerade via WireGuard)
/ip firewall nat add chain=srcnat out-interface=wg_radiustrend action=masquerade comment="NAT to Core"

# Routing Default
/ip route add gateway=10.100.0.1 distance=1 check-gateway=ping

/log info message="DANELA NET Provisioning V2 Completed for ${nas.name}"
`;


  // Fungsi Copy to Clipboard dengan Fallback
  const handleCopyScript = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      // Metode Modern (HTTPS / Localhost)
      navigator.clipboard.writeText(scriptContent)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 3000);
        })
        .catch((err) => console.error("Gagal menyalin: ", err));
    } else {
      // Metode Cadangan / Fallback (HTTP Biasa)
      const textArea = document.createElement("textarea");
      textArea.value = scriptContent;
      textArea.style.position = "fixed"; // Hindari scrolling ke bawah
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      } catch (err) {
        console.error("Gagal menyalin dengan metode fallback: ", err);
      }
      document.body.removeChild(textArea);
    }
  };

  // Fungsi Copy Teks Biasa dengan Fallback
  const handleCopyText = (text) => {
    if (!text) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => alert("Disalin: " + text))
        .catch((err) => console.error("Gagal menyalin: ", err));
    } else {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
        alert("Disalin: " + text);
      } catch (err) {
        console.error("Gagal menyalin: ", err);
      }
      document.body.removeChild(textArea);
    }
  };

  const sectionStyle = {
    background: "rgba(15, 23, 42, 0.5)",
    border: "1px solid rgba(51, 65, 85, 0.3)",
    backdropFilter: "blur(12px)",
  };

  const terminalStyle = {
    background: "#0f172a",
    border: "1px solid #334155",
    fontFamily: "'Fira Code', 'Courier New', monospace",
  };

  // Loading & Error Handling Sederhana
  if (isLoading) return <div className="p-10 text-center text-white">Memuat data...</div>;
  if (error) return <div className="p-10 text-center text-red-400">Gagal memuat data.</div>;


  return (
    <>
      <Helmet>
        <title>NAS {nas.name || "Detail"} | DANELA NET</title>
        <meta name="description" content={`Manajemen dan konfigurasi NAS MikroTik ${nas.name}.`} />
      </Helmet>

      <DashboardLayout showSidebar={openSidebar} setShowSidebar={setOpenSidebar}>
        {/* ===== Header ===== */}
        <Header showToggleSidebar={false} toggleSidebar={() => setOpenSidebar(!openSidebar)}>
          <div className="flex items-center justify-between w-full gap-4 flex-wrap md:flex-nowrap">
            <div className="flex items-center gap-4 py-2 min-w-0">
              <button
                onClick={() => navigate(-1)}
                className="p-2.5 rounded-xl text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 transition-all flex-shrink-0"
                style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
              >
                <FaArrowLeft />
              </button>
              <div className="min-w-0">
                <h1 className="font-bold tracking-tight text-gray-100 truncate">
                  NAS: {nas.name || "Tanpa Nama"}
                </h1>
              </div>
            </div>
          </div>
        </Header>

        <div className="p-4 lg:p-6 space-y-6">

          {/* ===== 1. Grid Statistik (Menggunakan Data API) ===== */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <StatCard label="IP Hotspot" value={nas.ip_hotspot || "-"} icon={<FaServer className="text-cyan-400" />} />
            <StatCard label="IP PPPoE" value={nas.ip_pppoe || "-"} icon={<FaNetworkWired className="text-amber-400" />} />
            <StatCard label="IP Tunnel" value={nas.ip_address || "-"} icon={<FaShieldAlt className="text-purple-400" />} />
            <StatCard label="Radius Secret" value={nas.secret ? "***" : "-"} icon={<FaKey className="text-emerald-400" />} />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

            {/* ===== 2. Detail Info NAS (Kiri) ===== */}
            <div className="lg:col-span-1">
              <div className="p-5 rounded-2xl h-full" style={sectionStyle}>
                <h3 className="font-bold text-gray-100 mb-4 flex items-center gap-2 text-sm">
                  <FaServer className="text-cyan-400" /> Informasi Perangkat
                </h3>
                <div className="space-y-2 text-xs">
                <NasDetailInfoItem
                    label="POP"
                    value={nas?.pop?.name ||""}
                    enableCopy={false}
                  />
                  <NasDetailInfoItem label="NAMA DEVICE" value={nas.name || "-"} onCopy={handleCopyText} />
                  <NasDetailInfoItem label="IP ADDRESS" value={nas.ip_address || "-"} isLink={nas.ip_address ? `http://${nas.ip_address}` : null} />
                  <NasDetailInfoItem
                    label="STATUS"
                    value={
                      <ConnectionStatusBadge status={nas.status} />
                    }
                    enableCopy={false}
                  />

                  <div className="pt-4" style={{ borderTop: "1px dashed rgba(51, 65, 85, 0.4)" }}>
                    <p className="text-[9px] font-bold text-slate-500 uppercase mb-2 tracking-widest">WireGuard Config</p>
                    <div className="space-y-2">
                      <NasDetailInfoItem
                        label="Public Key"
                        value={nas.public_key_wireguard || "Belum Dikonfigurasi"}
                        onCopy={handleCopyText}
                        icon={<FaKey size={10} className="text-cyan-500" />}
                      />
                      <NasDetailInfoItem
                        label="Radius Secret"
                        value={nas.secret || "-"}
                        onCopy={handleCopyText}
                        icon={<FaShieldAlt size={10} className="text-amber-500" />}
                      />
                    </div>
                  </div>

                  <div className="pt-4" style={{ borderTop: "1px dashed rgba(51, 65, 85, 0.4)" }}>
                    <p className="text-[9px] font-bold text-slate-500 uppercase mb-2 tracking-widest">Aksi Cepat</p>
                    <div className="grid grid-cols-2 gap-2">
                      <button
                        type="button"
                        onClick={() => setOpenModalUpdateName(true)}
                        className="flex items-center justify-center gap-2 p-2 rounded-lg bg-slate-800 text-slate-300 text-[10px] hover:bg-slate-700 hover:text-white transition-all border border-slate-700"
                      >
                        Update Nas / Mikrotik
                      </button>
                      <button
                        type="button"
                        onClick={() => setOpenModalUpdateName(true)}
                        className="flex items-center justify-center gap-2 p-2 rounded-lg bg-slate-800 text-slate-300 text-[10px] hover:bg-slate-700 hover:text-white transition-all border border-slate-700"
                      >
                        Update Wireguard
                      </button>
                      {/* <button className="flex items-center justify-center gap-2 p-2 rounded-lg bg-slate-800 text-slate-300 text-[10px] hover:bg-slate-700 hover:text-white transition-all border border-slate-700">
                        <FaDownload size={10} /> Backup Config
                      </button> */}
                      {/* <button className="flex items-center justify-center gap-2 p-2 rounded-lg bg-slate-800 text-slate-300 text-[10px] hover:bg-slate-700 hover:text-white transition-all border border-slate-700">
                        <FaTerminal size={10} /> Remote SSH
                      </button> */}
                      <Link to={`/dashboard/master-data/nas/detail/${nas.id}/config`} className="flex items-center justify-center gap-2 p-2 rounded-lg bg-slate-800 text-slate-300 text-[10px] hover:bg-slate-700 hover:text-white transition-all border border-slate-700">
                        Mikrotik Config
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ===== 3. Script & Tutorial (Kanan - 2 Kolom) ===== */}
            <div className="lg:col-span-2 space-y-6">

              {/* A. Script Terminal Section */}
              <div className="rounded-2xl overflow-hidden" style={sectionStyle}>
                <div className="flex items-center justify-between p-4" style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.2)" }}>
                  <h3 className="font-bold text-gray-100 flex items-center gap-2 text-sm">
                    <FaTerminal className="text-emerald-400" /> Script Konfigurasi (WireGuard & VLAN)
                  </h3>
                  <button
                    onClick={handleCopyScript}
                    className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all uppercase tracking-wider border ${copied
                      ? 'bg-emerald-600 text-white border-emerald-600'
                      : 'bg-slate-800 text-slate-300 border-slate-600 hover:bg-slate-700'
                      }`}
                  >
                    {copied ? <><FaClipboardCheck /> Copied!</> : <><FaCopy /> Salin Script</>}
                  </button>
                </div>

                <div className="p-4 relative group">
                  <div
                    className="w-full h-72 overflow-y-auto p-4 rounded-lg text-xs text-emerald-400 shadow-inner"
                    style={terminalStyle}
                  >
                    <pre style={{ whiteSpace: "pre-wrap", fontFamily: "inherit" }}>
                      {scriptContent}
                    </pre>
                  </div>
                </div>
              </div>

              {/* B. Tutorial Instalasi Section */}
              <div className="p-5 rounded-2xl" style={sectionStyle}>
                <h3 className="font-bold text-gray-100 mb-4 flex items-center gap-2 text-sm">
                  <FaBookOpen className="text-amber-400" /> Tutorial Setup WireGuard & VLAN
                </h3>

                <div className="space-y-4">
                  {[
                    { step: 1, title: "Generate Key Pair", desc: "Jalankan perintah '/interface wireguard generate-key' di terminal NAS Anda untuk mendapatkan Private Key, lalu timpa placeholder di script." },
                    { step: 2, title: "Setup VLAN & IP", desc: "Script ini otomatis membuat VLAN ID 10 (PPPoE) dan 20 (Hotspot) di atas 'bridge-local'. Pastikan 'bridge-local' sudah ada." },
                    { step: 3, title: "Eksekusi Script", desc: "Paste script yang disalin ke New Terminal MikroTik. Pastikan koneksi internet stabil untuk menghubungkan endpoint WireGuard." },
                    { step: 4, title: "Verifikasi Tunnel", desc: "Cek menu 'Interfaces' > 'WireGuard'. Pastikan status peer 'Core Server' menunjukkan handshake sukses." },
                  ].map((item) => (
                    <div key={item.step} className="flex gap-4">
                      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center text-cyan-400 font-bold text-xs">
                        {item.step}
                      </div>
                      <div className="pb-4 border-b border-slate-700/50 last:border-0 w-full">
                        <h4 className="text-sm font-bold text-slate-200 mb-1">{item.title}</h4>
                        <p className="text-xs text-slate-400 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

            </div>
          </div>

        </div>
      </DashboardLayout>

      <UpdateNasName
        open={openModalUpdateName}
        setOpen={setOpenModalUpdateName}
        refreshData={refreshData}
        selectedNas={data}
      />
    </>
  );
};

const StatCard = ({ label, value, icon }) => (
  <div
    className="p-4 rounded-xl border transition-all duration-300 hover:bg-slate-800/50 group"
    style={{
      background: "rgba(15, 23, 42, 0.4)",
      borderColor: "rgba(51, 65, 85, 0.3)"
    }}
  >
    <div className="flex justify-between items-start mb-2">
      <span className="text-[10px] font-bold text-slate-500 uppercase tracking-wider">{label}</span>
      <div className="p-1.5 rounded-lg bg-slate-800 text-slate-400 group-hover:text-white group-hover:bg-slate-700 transition-colors">
        {icon}
      </div>
    </div>
    <p className="text-sm md:text-base font-extrabold text-white tracking-tight truncate" title={value}>
      {value}
    </p>
  </div>
);
